module.exports = __webpack_public_path__ + "static/media/portarod-five-rod-holder.ed92b559.jpg";